import { render, staticRenderFns } from "./TabHeaderCustTag.vue?vue&type=template&id=6943e615"
import script from "./TabHeaderCustTag.vue?vue&type=script&lang=js"
export * from "./TabHeaderCustTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports